import { render, staticRenderFns } from "./supervisorRight.vue?vue&type=template&id=58288b85"
import script from "./supervisorRight.vue?vue&type=script&lang=js"
export * from "./supervisorRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports